import React, { useState, useEffect, useContext } from "react";
import axios from "../utils/axios";
import RoundedTag from "../VibehutUI/RoundedTag";
import ResourceInfoCard from "../VibehutUI/ResourceInfoCard";
import { getUserData } from "../services/userService";
import { StoreContext } from "../Context/StoreContext";
import ResourceModal from "../VibehutUI/ResourceModal";
import { deleteResource } from "../services/rooomService";
import { Link } from "react-router-dom";
import { resourceRoutes } from "../routes";
import { isMobile } from "../utils/utils";
import ResourceSkeleton from "../VibehutUI/Skeletons/ResourceSkeleton";

function Resources({ tagsLocation, roomId, roomOwner }) {
  //on clicking outside rounded tags the state should be reset to default

  const [selectedTag, setSelectedTag] = useState({
    index: 0,
    name: tagsLocation.tags?.length > 0 ? tagsLocation.tags[0] : "",
  });
  const [isAllTagVisible, setIsAllTagVisible] = useState(
    tagsLocation?.tag?.length > 15 ? true : false,
  );
  const { state } = useContext(StoreContext);
  const {
    auth: { user },
  } = state;
  const [selectedLocation, setSelectedLocation] = useState({
    index: 0,
    name: "",
  });
  const [roomResources, setRoomResources] = useState([]);
  const [isResourceModalOpen, setIsResourceModalOpen] = useState(false);
  const [roomResourceState, setRoomResourceState] = useState(null);
  const [isFetchingRoomResource, setIsFetchingRoomResource] = useState(false);
  const RESOURCES_FILTER_OBJECT = {
    RECENT: "RECENT",
    POPULAR: "POPULAR",
  };
  const [filter, setFilter] = useState(RESOURCES_FILTER_OBJECT.RECENT);

  useEffect(() => {
    setRoomResourceState(filterResourcesByTag(selectedTag.name));
  }, [roomResources]);

  function filterResourcesByTag(tag, location) {
    if (location) {
      if (tag === "all") {
        return roomResources.filter(
          (resource) => resource.location[0] === location,
        );
      }
      return roomResources.filter((resource) => {
        let flag = false;
        resource.tags.map((tagVal) => {
          if (tagVal == tag) {
            flag = true;
          }
        });
        return flag && resource.location[0] === location;
      });
    } else {
      if (tag === "all") {
        return roomResources;
      }
      return roomResources.filter((resource) => {
        let flag = false;
        resource.tags.map((tagVal) => {
          if (tagVal == tag) {
            flag = true;
          }
        });
        return flag;
      });
    }
  }

  useEffect(() => {
    setIsFetchingRoomResource(true);
    axios
      .get(`/rooms/get-room-resources-list/${roomId}?filter=${filter}`, {
        headers: user?.token
          ? {
              Authorization: `Bearer ${user.token}`,
              "Content-Type": "application/json",
            }
          : {},
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data && res.data.data && res.data.data.length > 0) {
            setRoomResources(res.data.data);
          }
        } else {
          console.log(res);
        }
      })
      .catch((error) => {
        console.log("error::", error);
      })
      .finally(() => {
        setIsFetchingRoomResource(false);
      });
  }, [filter]);

  const handleDelete = async (resourceId) => {
    await deleteResource(resourceId, user?.token)
      .then((res) => {
        let resourcesState = [...roomResourceState];
        resourcesState = resourcesState.filter(
          (resource) => resource._id !== resourceId,
        );
        setRoomResourceState(resourcesState);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <div className="flex pb-2">
        <p className="text-base font-bold pb-2 text-black dark:text-frescoWhite">
          Resources
        </p>
        <div className="flex gap-2 md:gap-3 ml-auto	">
          <Link
            to={resourceRoutes.path}
            className="cusBtn cusBtn-vibhut-primary-outline cusBtn-vibhut-sm font-medium text-center items-center flex"
          >
            <div className="cursor-pointer max-w-md">
              New {!isMobile() && "Resource"}
            </div>
          </Link>
          <div
            className={`${
              filter === RESOURCES_FILTER_OBJECT.RECENT
                ? "text-white bg-primary "
                : "text-matteGray bg-frescoWhite  "
            } cursor-pointer py-2 px-2 md:px-3 text-sm md:text-base rounded-lg font-medium`}
            onClick={() => {
              setFilter(RESOURCES_FILTER_OBJECT.RECENT);
            }}
          >
            Recent
          </div>
          <div
            className={`${
              filter === RESOURCES_FILTER_OBJECT.POPULAR
                ? "text-white bg-primary "
                : "text-matteGray bg-frescoWhite "
            } cursor-pointer py-2 px-2 md:px-3 text-sm md:text-base rounded-lg font-medium`}
            onClick={async () => {
              setFilter(RESOURCES_FILTER_OBJECT.POPULAR);
            }}
          >
            Popular
          </div>
        </div>
      </div>

      {/* <h1 className="text-black text-base font-bold font-ubuntu dark:text-frescoWhite pt-[10px]"></h1> */}
      {tagsLocation.tags === 0 && roomResources.length === 0 && (
        <div className="pt-[4px]">
          <p className="text-sm font-normal  text-darkGray ">
            There are no resources available.
          </p>
        </div>
      )}
      {tagsLocation?.tags && tagsLocation?.tags.length > 0 && (
        <div
          className={`flex font-ubuntu pt-2.5 space-x-2.5 ${
            isAllTagVisible
              ? "flex-wrap"
              : "overflow-hidden overflow-x-auto custom-scrollbar"
          } `}
          style={{
            ...(tagsLocation.tags.length > 3
              ? {
                  containerType: "inline-size",
                }
              : {
                  width: "fit-content",
                }),
          }}
        >
          {tagsLocation.tags &&
            tagsLocation.tags
              .slice(0, isAllTagVisible ? tagsLocation.tags.length : 15)
              .map((tag, index) => {
                return (
                  <RoundedTag
                    key={index}
                    onClick={() => {
                      setSelectedTag({ index: index, name: tag });
                      setSelectedLocation({ index: 0, name: "" });
                      setRoomResourceState(filterResourcesByTag(tag));
                    }}
                    title={tag}
                    textColor={"black"}
                    darkModeBorderColor={"lightGray"}
                    darkModeTextColor={"black"}
                    darkModeBackgroundColor={"lightGray"}
                    borderColor={"lightGray"}
                    bgColor={"lightGray"}
                    fontWeight={
                      selectedTag?.index === index ? "bold" : "normal"
                    }
                    roundPercent={"full"}
                  />
                );
              })}
        </div>
      )}
      {tagsLocation?.tags?.length > 15 && (
        <p
          className="text-black text-sm font-ubuntu dark:text-frescoWhite pt-2 underline text-right cursor-pointer"
          onClick={() => {
            setIsAllTagVisible(!isAllTagVisible);
          }}
        >
          {isAllTagVisible ? "See Less Tags" : "See All Tags"}
        </p>
      )}
      {tagsLocation.location && tagsLocation.location.length > 0 && (
        <div className="flex flex-wrap font-ubuntu">
          {tagsLocation.location &&
            tagsLocation.location.map((locate, index) => {
              return (
                <div key={index} className="pt-[10px] pr-[8px]">
                  <RoundedTag
                    title={locate}
                    onClick={() => {
                      setSelectedLocation({ index: index, name: locate });
                      setRoomResourceState(
                        filterResourcesByTag(selectedTag.name, locate),
                      );
                    }}
                    textColor={"primary"}
                    borderColor={"primary"}
                    darkModeBorderColor={"primary"}
                    darkModeTextColor={"primary"}
                    darkModeBackgroundColor={"secondary"}
                    bgColor={"secondary"}
                    fontWeight={
                      selectedLocation?.name === locate ? "bold" : "normal"
                    }
                    roundPercent={"full"}
                  />
                </div>
              );
            })}
        </div>
      )}
      {isFetchingRoomResource && (
        <div className="pt-[4px]">
          <ResourceSkeleton />{" "}
        </div>
      )}
      {roomResources.length > 0 && roomResourceState.length === 0 && (
        <div className="">
          <p className="text-sm font-normal  text-darkGray pt-2">
            There are no resources available for current filter.
          </p>
        </div>
      )}
      {roomResourceState &&
        roomResourceState.slice(0, 10).map((resource, index) => {
          return (
            <div key={resource._id + index} className="">
              <ResourceInfoCard
                companyName={resource.companyName}
                tags={resource.tags}
                label={resource.label}
                location={resource.location[0]}
                testimonial={resource.testimonial}
                url={resource.url}
                count={resource.count}
                id={resource._id}
                description={resource.description}
                votes={resource.votes || []}
                createdAt={resource.createdAt || new Date()}
                diamondsGivenBySenders={resource.diamondsGivenBySenders}
                username={
                  resource.owner && resource.owner.length > 0
                    ? getUserData(resource.owner[0]).username
                    : ""
                }
                chatCount={
                  resource?.specificChatRoom[0]?.chatCount
                    ? resource.specificChatRoom[0].chatCount
                    : 0
                }
                roomOwner={roomOwner}
                ownerId={resource.owner[0]?._id}
                roomId={roomId}
                handleDelete={handleDelete}
                resourceOwner={
                  resource.owner && resource.owner.length > 0
                    ? getUserData(resource.owner[0])
                    : ""
                }
              />
            </div>
          );
        })}
      {roomResourceState?.length > 10 && (
        <p
          className="text-black text-sm font-ubuntu dark:text-frescoWhite pt-2 underline text-right cursor-pointer"
          onClick={() => {
            setIsResourceModalOpen(!isResourceModalOpen);
          }}
        >
          See All
        </p>
      )}
      <ResourceModal
        isOpen={isResourceModalOpen}
        setIsOpen={setIsResourceModalOpen}
        tag={selectedTag.name}
        roomResourceState={roomResourceState}
        roomId={roomId}
        roomOwner={roomOwner}
      />
    </div>
  );
}

export default Resources;
